import { ParseKeys } from "i18next";

/**
 * The Ja/Nein/Unbekannt answers a claim's Strittig, Sicherheiten, Forderung zur Gänze strittig and
 * Im SRV angemeldet fields carry. A closed set defined here rather than an administrable dropdown:
 * the backend branches on these exact values, so they are part of the contract, not configuration.
 *
 * The values are the strings the API sends and expects; the German words live in the i18n catalog
 * below, so the two cannot be confused.
 */
export const ClaimStatusKey = {
  Yes: "JA",
  No: "NEIN",
  Unknown: "UNBEKANNT",
} as const;

export type ClaimStatusKey = (typeof ClaimStatusKey)[keyof typeof ClaimStatusKey];

/** Every status, in the order the claim dialog offers them. */
export const CLAIM_STATUS_OPTIONS: ClaimStatusKey[] = [ClaimStatusKey.Yes, ClaimStatusKey.No, ClaimStatusKey.Unknown];

/**
 * The two optional fields offer only Ja and Nein — leaving them blank is what "unknown" means
 * there, so an explicit Unbekannt would be a second way to say the same thing.
 */
export const CLAIM_STATUS_YES_NO_OPTIONS: ClaimStatusKey[] = [ClaimStatusKey.Yes, ClaimStatusKey.No];

// Record<ClaimStatusKey, …> rather than a plain object: a new status is a compile error here until
// it has a label.
const CLAIM_STATUS_LABEL_KEYS: Record<ClaimStatusKey, ParseKeys> = {
  JA: "claims.form.statusOptions.yes",
  NEIN: "claims.form.statusOptions.no",
  UNBEKANNT: "claims.form.statusOptions.unknown",
};

/** Returns the catalog key, not the translated word, so callers own the `t()` call. */
export function claimStatusLabelKey(status: ClaimStatusKey): ParseKeys {
  return CLAIM_STATUS_LABEL_KEYS[status];
}
